<script>
import NavBar from '@components/nav-bar.vue'

export default {
  components: { NavBar },
  props: {
    wayNumber: {
      type: Number,
      default: 1,
    },
    wayName: {
      type: String,
      default: 'Exploration',
    },
    nextLoc: {
      type: String,
      default: 'Location A',
    },
    nextTitle: {
      type: String,
      default: '',
    },
    hideBack: {
      type: Boolean,
      default: false,
    },
    hideNext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      explorationPage:
        this.$route.name === 'exploration-overview'
          ? 'exploration-overview'
          : this.$route.name === 'exploration-planning'
          ? 'exploration-planning'
          : this.$route.name === 'exploration-drilling'
          ? 'exploration-drilling'
          : this.$route.name === 'resource-model'
          ? 'resource-model'
          : this.$route.name === 'rock-characterization'
          ? 'rock-characterization'
          : '',
      planningPage:
        this.$route.name === 'planning-overview'
          ? 'planning-overview'
          : this.$route.name === 'planning-locationa'
          ? 'planning-locationa'
          : '00-planning-overview',
    }
  },
  methods: {},
}
</script>

<template>
  <div>
    <!-- Header -->

    <header class="header">
      <NavBar v-if="this.$route.name !== 'home'" />
      <div v-if="this.$route.name !== 'home'" class="header__secondary">
        <div class="header__marker header__wayfinder header__wayfinder--left">
          <h1 class="header__wayfinder-label">
            <span class="header__wayfinder-number">Path 0{{ wayNumber }}:</span>
            <span class="header__wayfinder-name">{{ wayName }}</span>
          </h1>
        </div>

        <nav class="header__seeker">
          <div
            v-if="!hideBack"
            class="header__wayfinder header__wayfinder--right"
          >
            <svg class="header__arrow" viewBox="0 0 32 10">
              <line x1="0" x2="5" y1="5" y2="0" />
              <line x1="0" x2="32" y1="5" y2="5" />
              <line x1="0" x2="5" y1="5" y2="10" />
            </svg>
          </div>

          <div v-if="!hideNext" class="header__wayfinder">
            <div class="header__next-stage header__wayfinder-label">
              <div class="header__wayfinder-label">
                <span class="header__wayfinder-number">
                  Next: {{ nextLoc }}
                </span>
                <span class="header__wayfinder-name">
                  {{ nextTitle }}
                </span>
              </div>

              <svg class="header__arrow" viewBox="0 0 32 10">
                <line x1="27" x2="32" y1="0" y2="5" />
                <line x1="0" x2="32" y1="5" y2="5" />
                <line x1="27" x2="32" y1="10" y2="5" />
              </svg>
            </div>
          </div>
        </nav>
      </div>
    </header>

    <div class="ui">
      <div v-if="this.$route.name !== 'home'">
        <BaseMenuButton v-if="this.$route.name !== 'home'" />
        <BaseSideDrawer>
          <!-- Paths -->
          <!-- Put this inside of a content box sans the connector -->

          <div v-if="this.$route.name !== 'home'" class="paths c-box__content">
            <header class="paths__header">
              <h2 class="paths__title">
                Pick your Path
              </h2>

              <p>
                Explore the Life of Mine. Discover the Hexagon difference. Where
                would you like to start?
              </p>
            </header>
            <nav class="paths__nav">
              <div class="paths__nav-link">
                <div class="paths__nav-item">
                  <router-link :to="{ name: 'exploration-overview' }">
                    <span class="paths__nav-number">01</span>
                    <span class="paths__nav-name">Exploration</span>
                  </router-link>
                </div>
              </div>

              <div class="paths__nav-link">
                <div class="paths__nav-item">
                  <router-link :to="{ name: '02-planning-overview' }">
                    <span class="paths__nav-number">02</span>
                    <span class="paths__nav-name">Planning</span>
                  </router-link>
                </div>
              </div>

              <div class="paths__nav-link">
                <div class="paths__nav-item">
                  <router-link :to="{ name: 'drilling-blast-overview' }">
                    <span class="paths__nav-number">03</span>
                    <span class="paths__nav-name">Drill &amp; Blast</span>
                  </router-link>
                </div>
              </div>

              <div class="paths__nav-link">
                <div class="paths__nav-item">
                  <router-link :to="{ name: 'material-movement-overview' }">
                    <span class="paths__nav-number">04</span>
                    <span class="paths__nav-name">Material Movement</span>
                  </router-link>
                </div>
              </div>

              <div class="paths__nav-link">
                <div class="paths__nav-item">
                  <router-link :to="{ name: '02-planning-overview' }">
                    <span class="paths__nav-number">05</span>
                    <span class="paths__nav-name">Survey &amp; Monitoring</span>
                  </router-link>
                </div>
              </div>
            </nav>
          </div>
        </BaseSideDrawer>
      </div>
    </div>

    <div class="stage">
      <!-- The inner stage is set to always be a 16:9 aspect ratio and float in the middle of the screen -->
      <!-- This will allow us to position things true to the video no matter the screen size -->

      <div class="stage__inner">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

/* stylelint-disable */

// Normalize
// ---------------------------------------------------------- //

html,
body {
  height: 100%;
}

body {
  font-family: 'Hexagon';
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  margin: 0;
}

body * {
  box-sizing: border-box;
}

// Header
// ---------------------------------------------------------- //

.header {
  $block: &;

  $xPadding: 1.25rem;
  $yPadding: 0.625rem;
  $logoMargin: 0.75rem;

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  @at-root {
    &__main {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $brandDarkBlueTransparent;
      padding: $yPadding $xPadding;
      color: $brandWhite;
      z-index: 10;
    }

    &__brand {
      display: flex;
      align-items: center;
    }

    &__logo-container {
      position: relative;
      width: 8.375rem;
      margin-right: $logoMargin;
    }

    &__logo {
      display: block;
      margin-bottom: 3%;
    }

    &__title {
      position: relative;
      padding-left: $logoMargin;
      font-size: 1.1rem;
      line-height: 1;
      font-weight: 400;
      text-transform: uppercase;
      padding-bottom: 0.2rem;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 20%;
        left: 0;
        border-left: 1px solid $brandWhite;
      }
    }

    // The secondary header
    // This is where the markers and wayfinders are

    &__secondary {
      display: flex;
      justify-content: space-between;
      border-top: 2px solid $brandWhite;
      position: relative;
      z-index: 10;
    }

    &__wayfinder {
      $slantyBoiWidth: 4rem;
      $slantyBoiPos: calc(100% - #{$slantyBoiWidth} / 2);
      $slantyBoiSkew: 45deg;

      display: flex;
      align-items: center;
      position: relative;
      z-index: 0;
      background-color: $brandWhite;
      padding: $yPadding $xPadding;
      color: $brandMidBlue;

      // Little slanty bois

      &--left,
      &--right {
        &::after {
          content: '';
          position: absolute;
          z-index: -1;
          top: 0;
          width: 4rem;
          height: 100%;
          background-color: $brandWhite;
        }
      }

      &--left {
        &::after {
          left: $slantyBoiPos;
          transform: skewX(-$slantyBoiSkew);
        }
      }

      &--right {
        padding-left: $xPadding / 3;

        &::after {
          right: $slantyBoiPos;
          transform: skewX($slantyBoiSkew);
        }
      }

      &-label {
        text-transform: uppercase;
        margin: 0;
      }

      &-number,
      &-name {
        display: block;
      }

      &-number {
        font-size: 0.6875rem;
        font-weight: 400;
      }

      &-name {
        font-size: 0.875rem;
        font-weight: 900;
      }
    }

    &__seeker {
      display: flex;

      #{$block}__wayfinder:not(:last-child) {
        margin-right: 0.1875rem;
      }
    }

    &__arrow {
      width: 2rem;
      overflow: visible;

      line {
        stroke: $brandMidBlue;
        stroke-width: 2;
        vector-effect: non-scaling-stroke;
      }
    }

    &__next-stage {
      display: flex;
      align-items: center;

      #{$block}__wayfinder-label {
        margin-right: 0.75rem;
      }
    }
  }
}

// The content box
// You've probably seen this before

.c-box {
  $block: &;

  $outerOffset: 1rem;
  $cornerOffset: 2rem;
  $paddingMain: 2rem;
  $paddingBevel: 2.5rem;

  display: inline-block;
  visibility: hidden;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;

  // All SVGs and SVG lines
  // vector-effect forces the stroke to be in pixel space

  svg {
    pointer-events: none;
    overflow: visible;
  }

  line {
    stroke-width: 1.666;
    stroke: white;
    vector-effect: non-scaling-stroke;
  }

  @at-root {
    // Clip path clips BG & content in case of videos/full-width things

    &__background,
    &__content {
      clip-path: polygon(
        0 0,
        0 0,
        0 0,
        100% 0,
        100% calc(100% - #{$cornerOffset}),
        calc(100% - #{$cornerOffset}) 100%,
        0 100%,
        0 0
      );
    }

    &__background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $brandDarkBlueTransparent;
    }

    &__content {
      padding: $paddingMain $paddingBevel $paddingMain $paddingMain;
      font-size: 0.9375rem;
      line-height: 1.5;

      // Definitely need some sensible global-esque styles here

      h2 {
        font-size: 1.375rem;
        font-weight: 900;
        text-transform: uppercase;
      }
    }

    &__inner-line,
    &__outer-line,
    &__connector-line {
      position: absolute;
      z-index: 1;
    }

    // The inner line
    // Plain 'ol transforms are used to offset shortcomings of top-left SVG origin

    &__inner-line {
      top: 0;
      width: 100%;
      height: 100%;

      line:nth-child(2) {
        transform: translate(0, -#{$cornerOffset});
      }

      line:nth-child(3) {
        transform: translate(
          calc(100% - #{$cornerOffset}),
          calc(100% - #{$cornerOffset})
        );
      }

      line:nth-child(4) {
        transform: translate(-#{$cornerOffset}, 0);
      }
    }

    // The outer line

    &__outer-line {
      top: 0;
      left: $outerOffset;
      width: calc(100% + #{$outerOffset} - #{$cornerOffset});
      height: calc(100% + #{$outerOffset});

      #{$block}--top-left &,
      #{$block}--top-right & {
        top: -$outerOffset;
        width: calc(100% + #{$outerOffset});
      }

      #{$block}--top-right & {
        left: 0;
        height: calc(100% - #{$outerOffset});
      }
    }

    // The connector line
    // Eventual width and height determined by JS

    &__connector-line {
      top: calc(100% + #{$outerOffset});
      right: calc(100% + #{$outerOffset});
      width: 0;
      height: 0;

      #{$block}--top-left &,
      #{$block}--top-right & {
        top: auto;
        bottom: calc(100% + #{$outerOffset});
      }

      #{$block}--top-right &,
      #{$block}--bottom-right & {
        right: auto;
      }

      #{$block}--top-right & {
        left: calc(100% + #{$outerOffset});
      }

      #{$block}--bottom-right & {
        left: calc(100% - #{$cornerOffset});
      }
    }
  }
}

// Stage
// ---------------------------------------------------------- //

.stage {
  $block: &;

  $videoAspectRatio: 16/9;
  $videoAspectRatioMediaQuery: '16/9';

  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @at-root {
    &__inner {
      position: relative;
      flex: auto 0 0;
      width: $videoAspectRatio * 100vh;
      height: 100vh;

      @media (min-aspect-ratio: $videoAspectRatioMediaQuery) {
        width: 100vw;
        height: 1 / $videoAspectRatio * 100vw;
      }
    }

    &__video,
    &__effects,
    &__overlays {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &__video {
      // BG image to test
      background-position: center;
      background-size: 100% auto;
      background-repeat: no-repeat;

      video {
        width: 100%;
      }
    }
  }
}

// Hotspots
// These are shown as an example of how they should be positioned and sized

.c-hotspot {
  $block: &;

  position: absolute;

  // Always do position and sizing in percentage values
  // These would be relative to the size of the video

  top: 29.5%;
  left: 31.5%;
  width: 8%;

  // Some other shit to make it visible for this test

  background-color: rgba(red, 0.5);
  border-radius: 50%;
  transform: rotateX(57deg) rotateY(0deg) rotateZ(0deg);

  // Pseudo element with padding maintains aspect ratio

  &::after {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

// The content box
// You've probably seen this before

.c-box {
  $block: &;

  $outerOffset: 1rem;
  $cornerOffset: 2rem;
  $paddingMain: 2rem;
  $paddingBevel: 2.5rem;

  display: inline-block;
  visibility: hidden;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;

  // All SVGs and SVG lines
  // vector-effect forces the stroke to be in pixel space

  svg {
    pointer-events: none;
    overflow: visible;
  }

  line {
    stroke-width: 1.666;
    stroke: white;
    vector-effect: non-scaling-stroke;
  }

  @at-root {
    // Clip path clips BG & content in case of videos/full-width things

    &__background,
    &__content {
      clip-path: polygon(
        0 0,
        0 0,
        0 0,
        100% 0,
        100% calc(100% - #{$cornerOffset}),
        calc(100% - #{$cornerOffset}) 100%,
        0 100%,
        0 0
      );
    }

    &__background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $brandDarkBlueTransparent;
    }

    &__content {
      padding: $paddingMain $paddingBevel $paddingMain $paddingMain;
      font-size: 0.9375rem;
      line-height: 1.5;

      // Definitely need some sensible global-esque styles here

      h2 {
        font-size: 1.375rem;
        font-weight: 900;
        text-transform: uppercase;
      }
    }

    &__inner-line,
    &__outer-line,
    &__connector-line {
      position: absolute;
      z-index: 1;
    }

    // The inner line
    // Plain 'ol transforms are used to offset shortcomings of top-left SVG origin

    &__inner-line {
      top: 0;
      width: 100%;
      height: 100%;

      line:nth-child(2) {
        transform: translate(0, -#{$cornerOffset});
      }

      line:nth-child(3) {
        transform: translate(
          calc(100% - #{$cornerOffset}),
          calc(100% - #{$cornerOffset})
        );
      }

      line:nth-child(4) {
        transform: translate(-#{$cornerOffset}, 0);
      }
    }

    // The outer line

    &__outer-line {
      top: 0;
      left: $outerOffset;
      width: calc(100% + #{$outerOffset} - #{$cornerOffset});
      height: calc(100% + #{$outerOffset});

      #{$block}--top-left &,
      #{$block}--top-right & {
        top: -$outerOffset;
        width: calc(100% + #{$outerOffset});
      }

      #{$block}--top-right & {
        left: 0;
        height: calc(100% - #{$outerOffset});
      }
    }

    // The connector line
    // Eventual width and height determined by JS

    &__connector-line {
      top: calc(100% + #{$outerOffset});
      right: calc(100% + #{$outerOffset});
      width: 0;
      height: 0;

      #{$block}--top-left &,
      #{$block}--top-right & {
        top: auto;
        bottom: calc(100% + #{$outerOffset});
      }

      #{$block}--top-right &,
      #{$block}--bottom-right & {
        right: auto;
      }

      #{$block}--top-right & {
        left: calc(100% + #{$outerOffset});
      }

      #{$block}--bottom-right & {
        left: calc(100% - #{$cornerOffset});
      }
    }
  }
}

// UI
// ---------------------------------------------------------- //

// Since almost everything not dynamic is centered, I made the container a flexy boi

.ui {
  $block: &;

  $padding: 3rem;

  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: $padding;
}

.paths {
  $block: &;

  $paddingMain: 1.5rem;
  $paddingBottom: 3.25rem;

  width: 33.33333333%;
  min-width: 315px;
  max-width: 375px;
  padding: $paddingMain $paddingMain $paddingBottom $paddingMain;

  // For the sake of right now
  visibility: visible;
  position: relative;
  background-color: $brandDarkBlueTransparent;
  color: $brandWhite;

  @at-root {
    &__header {
      margin-bottom: $paddingMain;

      :last-child {
        margin-bottom: 0;
      }
    }

    &__title {
      padding-bottom: $paddingMain / 2;
      border-bottom: 1px solid $brandWhite;
      margin-top: 0;
      margin-right: $paddingMain;
      margin-bottom: $paddingMain * 0.75;
    }

    &__nav {
      $nav: &;

      $linkPadding: 0.5rem;
      $numberMargin: 0.5rem;

      &-link {
        padding: $linkPadding $linkPadding $linkPadding 0;
        margin-bottom: 1rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        font-size: 1rem;
        line-height: 1;

        #{$nav}-link:hover &,
        #{$nav}-link:focus & {
          // Hover FX here
        }
      }

      &-number {
        font-weight: 400;
        width: 2ch;
        margin-right: $numberMargin;
      }

      &-name {
        position: relative;
        font-weight: 900;
        text-transform: uppercase;
        padding-left: $numberMargin;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 20%;
          left: 0;
          border-left: 1px solid $brandWhite;
        }
      }
    }
  }
}

/* stylelint-enable */

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
